<template>
  <div class="diseaseList">
    <!-- 筛选查询框 -->
    <el-form :inline="true" size="mini" style="margin: 10px auto">
      <el-form-item label="卡券名称: " style="margin-left: 20px">
        <el-input v-model="listQuery.couponTitle" placeholder="请输入" style="width: 180px" clearable></el-input>
      </el-form-item>
      <el-form-item label="卡号: " style="margin-left: 20px">
        <el-input v-model="listQuery.cardNumber" placeholder="请输入" style="width: 180px" clearable></el-input>
      </el-form-item>
      <el-form-item label="卡密: " style="margin-left: 20px">
        <el-input v-model="listQuery.password" placeholder="请输入" style="width: 180px" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left: 20px">
        <el-input v-model="listQuery.userPhone" placeholder="请输入" style="width: 180px" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态: " style="margin: 0 20px">
        <el-select style="width: 180px" v-model="listQuery.cardStatus" placeholder="请选择" clearable>
          <div v-for="(item, index) in cardStatusList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListData">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAdd">创建卡券</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="danger"
          :disabled="multipleSelection.length === 0"
          @click="handleBatchDelete"
        >批量删除</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
        >导出数据 Excel（ {{ tableData.length }} ）</el-button>
      </el-form-item>
    </el-form>

    <!-- 商品表格 -->

    <ElTable
      height="calc(100vh - 280px)"
      :columns="listHeader"
      :tableData="tableData"
      :loading="loading"
      :total="listQuery.total"
      @selection-change="handleSelectionChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    >
      <template slot="exchange_type" slot-scope="{ row }">
        <el-tag v-if="row.exchange_type === 1" type="success" effect="dark" size="mini">满减券</el-tag>
        <el-tag v-if="row.exchange_type === 2" effect="info" size="mini">商品券</el-tag>
        <el-tag v-if="row.exchange_type === 3" type="danger" effect="dark" size="mini">购物金</el-tag>
      </template>

      <template slot="writeOffTime" slot-scope="{ row }">{{ row.writeOffTime?row.writeOffTime:'-' }}</template>
      <template slot="exchangeTime" slot-scope="{ row }">{{ row.exchangeTime?row.exchangeTime:'-' }}</template>
      <template slot="userPhone" slot-scope="{ row }">{{ row.userPhone?row.userPhone:'-' }}</template>
      <template slot="cardStatus" slot-scope="{ row }">
        <el-tag v-if="row.cardStatus === 0" effect="dark" size="mini">待领取</el-tag>
        <el-tag v-else-if="row.cardStatus === 1" effect="dark" size="mini" type="danger">未核销</el-tag>
        <el-tag v-else type="success" effect="dark" size="mini">已核销</el-tag>
      </template>
      <template slot="operation" slot-scope="{ row }">
        <div class="operation">
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0);"
            @click="handleDelete(row)"
          >删除</el-button>
        </div>
      </template>
    </ElTable>

    <!-- 批量生成卡券弹窗 -->
    <el-dialog title="批量生成卡券" :visible.sync="couponVisible">
      <div style="margin: 20px; color: red">
        生成规则:
        XXXX(前位字符自己输入)+XXXX(设置一个数字起点,按数递增)
      </div>
      <el-form :model="dialogFormVisible" :label-width="formLabelWidth">
        <el-form-item label="卡号前字符" required>
          <el-input
            v-model="dialogForm.firstVipNumber"
            auto-complete="off"
            placeholder="通常为合作商字母或数字标识"
          ></el-input>
        </el-form-item>
        <el-form-item label="后四位起点" required>
          <el-input
            v-model="dialogForm.lastVipNumber"
            auto-complete="off"
            placeholder="通常为序号标识,写入生成的起点数字(4位数以内)"
            maxlength="4"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="卡券名称" required>
          <el-input v-model="dialogForm.couponTitle" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="卡券规格描述" required>
          <el-input v-model="dialogForm.msg" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="兑换类型" required>
          <el-radio-group v-model="dialogForm.exchange_type">
            <el-radio :label="1">满减券</el-radio>
            <!-- <el-radio :label="2">商品券</el-radio> -->
            <el-radio :label="3">省钱卡购物金</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="卡券金额"
          required
          v-if="dialogForm.exchange_type === 1 ||dialogForm.exchange_type === 3"
        >
          <el-input v-model.number="dialogForm.price" auto-complete="off" type="number"></el-input>
        </el-form-item>

        <el-form-item label="使用门槛" required v-if="dialogForm.exchange_type === 1">
          <el-input v-model.number="dialogForm.maxPrice" auto-complete="off" type="number"></el-input>
        </el-form-item>

        <el-form-item label="选择商品" required v-if="dialogForm.exchange_type === 2">
          <el-button
            size="small"
            type="primary"
            @click="showProductSelector"
          >{{ selectedProduct ? selectedProduct.productName : '点击选择商品' }}</el-button>
          <span
            v-if="selectedProduct"
            style="margin-left: 10px; color: #67C23A;"
          >已选择: {{ selectedProduct.productName }}</span>
        </el-form-item>

        <el-form-item label="生成数量" required>
          <el-input
            placeholder="单次数量小于1000"
            v-model.number="dialogForm.num"
            auto-complete="off"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="couponVisible = false">取消</el-button>
        <el-button type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>

    <!-- 商品选择对话框 -->
    <el-dialog title="选择商品" :visible.sync="productSelectorVisible" width="80%">
      <el-form :inline="true" size="mini">
        <el-form-item label="商品名称: ">
          <el-input v-model="productQuery.productName" placeholder="请输入商品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="商品编码: ">
          <el-input v-model="productQuery.productCode" placeholder="请输入商品编码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getProductList">搜索</el-button>
        </el-form-item>
      </el-form>

      <ElTable
        :columns="productListHeader"
        :tableData="productTableData"
        :loading="productLoading"
        :total="productQuery.total"
        :listQuery="productQuery"
        @handleCurrentChange="handleProductCurrentChange"
        @handleSizeChange="handleProductSizeChange"
      >
        <template slot="img" slot-scope="{ row }">
          <img :src="row.coverImg" alt style="width: 60px; height: 60px; object-fit: cover;" />
        </template>
        <!-- <template slot="status" slot-scope="{ row }">
          <el-tag v-if="row.status === 1" type="success" size="mini">上架</el-tag>
          <el-tag v-else type="info" size="mini">下架</el-tag>
        </template>-->
        <template slot="operation" slot-scope="{ row }">
          <el-button size="mini" type="primary" @click="handleProductSelect(row)">选择</el-button>
        </template>
      </ElTable>

      <div slot="footer" class="dialog-footer">
        <el-button @click="productSelectorVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { selectApi, deleteApi, addListApi } from "@/services/coupon/index.js";
import { selectGoods } from "@/services/mall/goods.js";

import XLSX from "xlsx";
import { mapState } from "vuex";
export default {
  components: {
    ElTable
  },

  async created() {
    this.getListData();
  },

  data() {
    return {
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      role_id: "",
      sum1: "",
      sum2: "",
      totalCount: 0,
      downloadLoading: false,
      dialogForm: {}, //新增卡券参数
      status: 0,
      goodsTitle: "",

      listQuery: {
        type: 2, // 1优惠券 2卡券
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      tableData: [],

      cardStatusList: [
        { id: 0, name: "未领取" },
        { id: 1, name: "未核销" },
        { id: 2, name: "已核销" }
      ],
      dialogFormVisible: false,
      dialogFormVisible: {},
      formLabelWidth: "120px",

      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      couponVisible: false,
      multipleSelection: [],

      // 商品选择相关
      productSelectorVisible: false,
      selectedProduct: null,
      productQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        productName: "",
        productCode: ""
      },
      productTableData: [],
      productLoading: false
    };
  },

  computed: {
    listHeader,
    // 商品列表表头
    productListHeader() {
      return [
        { label: "序号", type: "index", width: 60 },
        { label: "商品图片", prop: "coverImg", width: 100, slots: "img" },
        { label: "商品名称", prop: "productName", minWidth: 200 },
        { label: "商品编码", prop: "productCode", width: 150 },
        { label: "价格", prop: "price", width: 100 },
        // { label: "状态", prop: "status", width: 100, slots: "status" },
        {
          label: "操作",
          prop: "operation",
          width: 100,
          slots: "operation",
          fixed: "right"
        }
      ];
    },
    ...mapState(["userInfo", "filterStoreList"])
  },

  methods: {
    // 多选变化
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    // 批量删除
    async handleBatchDelete() {
      if (!this.multipleSelection.length) {
        return this.$message.warning("请先选择要删除的卡券");
      }
      try {
        await this.$confirm(
          `此操作将删除选中的 ${this.multipleSelection.length} 条记录，是否继续？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
      } catch (e) {
        return; // 取消
      }

      const ids = this.multipleSelection.map(i => i.id).filter(Boolean);
      if (!ids.length) return;

      this.loading = true;
      try {
        // 逐个删除:
        // await Promise.all(ids.map(id => deleteApi({ id })));
        //批量删除
        let result = await deleteApi({ id: ids });
        if (result.code === 200) {
          this.$message.success("批量删除成功");
          this.getListData();
          this.multipleSelection = [];
        } else {
          this.$message.error("部分或全部删除失败，请重试");
        }
      } catch (err) {
        this.$message.error("部分或全部删除失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectApi({
        ...listQuery
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      if (this.listQuery.total >= 50000) {
        return this.$message.error("当前卡券数据已达上限");
      }
      this.couponVisible = true;
      this.dialogForm = {
        exchange_type: 1 // 默认选择满减券
      };
      this.selectedProduct = null;
    },

    /* 编辑 */
    handleUpdate() {
      updateCardCoupon(this.form).then(resp => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.getListData();
        }
      });
    },

    /* 显示商品选择器 */
    showProductSelector() {
      this.productSelectorVisible = true;
      this.productQuery = {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        productName: "",
        productCode: ""
      };
      this.getProductList();
    },

    /* 获取商品列表 */
    async getProductList() {
      this.productLoading = true;
      try {
        const { data, code, count } = await selectGoods({
          pageNumber: this.productQuery.pageNumber,
          pageSize: this.productQuery.pageSize,
          productName: this.productQuery.productName,
          productCode: this.productQuery.productCode,
          type: 2 // 只查询商品类型为2的商品
        });
        if (code === 200) {
          this.productTableData = data;
          this.productQuery.total = count;
        }
      } catch (err) {
        console.error(err);
        this.$message.error("获取商品列表失败");
      } finally {
        this.productLoading = false;
      }
    },

    /* 商品选择 */
    handleProductSelect(row) {
      this.selectedProduct = row;
      this.dialogForm.product_id = row.id;
      this.productSelectorVisible = false;
      this.$message.success(`已选择商品: ${row.productName}`);
    },

    /* 商品列表分页 */
    handleProductCurrentChange(e) {
      this.productQuery.pageNumber = e;
      this.getProductList();
    },

    handleProductSizeChange(e) {
      this.productQuery.pageSize = e;
      this.getProductList();
    },

    /* 保存 */
    save() {
      if (!this.dialogForm.couponTitle) {
        this.$message.error("请填写卡券名称");
        return;
      }
      if (!this.dialogForm.msg) {
        this.$message.error("请填写卡券规格描述");
        return;
      }

      // 验证兑换类型
      if (!this.dialogForm.exchange_type) {
        this.$message.error("请选择兑换类型");
        return;
      }

      // 如果是商品券，验证是否选择了商品
      if (this.dialogForm.exchange_type === 2) {
        if (!this.dialogForm.product_id) {
          this.$message.error("请选择商品");
          return;
        }
      }

      if (this.dialogForm.exchange_type === 1) {
        if (!this.dialogForm.price) {
          this.$message.error("请填写优惠券价格");
          return;
        }
        if (!this.dialogForm.maxPrice && this.dialogForm.maxPrice !== 0) {
          this.$message.error("请填写满多少可用");
          return;
        }
      }

      if (
        !this.dialogForm.lastVipNumber ||
        this.dialogForm.lastVipNumber.length > 4
      ) {
        return this.$message.error("卡号后四位请输入4位数以内的数字");
      }

      if (!this.dialogForm.firstVipNumber) {
        return this.$message.error("卡号前位字符");
      }
      if (
        !this.dialogForm.lastVipNumber ||
        this.dialogForm.lastVipNumber.length > 4
      ) {
        return this.$message.error("卡号后四位请输入4位数以内的数字");
      }
      if (!this.dialogForm.num || this.dialogForm.num > 1000) {
        this.$message.error("请输入合法的数量");
        return;
      }
      this.loading = true;
      //生成卡号与卡密
      addListApi({
        ...this.dialogForm,
        type: 2, // 1优惠券 2卡券
        cardStatus: 0,
        source: 1 //来源
      })
        .then(resp => {
          if (resp.code === 200) {
            this.$message.success("新增成功");
            this.getListData();
            this.couponVisible = false;
            this.selectedProduct = null;
          } else {
            this.$message.error(resp.message || "新增失败，请重试");
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该卡券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    // 导出数据wangsheng_admin/src/vendor
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "卡券名称",
          "卡券规格描述",
          "卡号",
          "卡密",
          "价格",
          "门槛",
          "创建时间"
        ];
        const filterVal = [
          "couponTitle",
          "msg",
          "cardNumber",
          "password",
          "price",
          "maxPrice",
          "createTime"
        ];
        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "卡券列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    /*  导入物流单号 */
    importExcel(file) {
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some(item => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet; //导入的数据数组
          // console.log("------导入的数据为", this.xlsxJson, dateXlx);
          // 一项项导入数据
          dateXlx
            .map(item => {
              return {
                ...item
                // 物流单号: item?.["物流单号"] || null
              };
            })
            .forEach(item => {
              // console.log("item", item["物流单号"]);
              if (item["物流单号"] !== null) {
                console.log('item["物流单号"]', item["物流单号"]);
                updateSendState({
                  id: item.id,
                  logisticsNumber: item["物流单号"]
                }).then(() => {
                  // console.log(res);
                  this.getListData();
                });
              } else {
                this.$message.error("请检查表格数据是否完整");
              }
            });
        }
      });
    },

    file2Xce(file) {
      // return new Promise(function (resolve, reject) {
      return new Promise(function(resolve) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary"
          });
          const result = [];
          this.wb.SheetNames.forEach(sheetName => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  padding: 20px;
  width: 100%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
.sku {
  border: 1px dotted rgb(189, 189, 189);
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}
.sku > div {
  margin-right: 10px;
  padding: 10px 20px;
  background: rgb(245, 138, 44);
  border-radius: 10px;
  color: white;
}
.sku > div:hover {
  cursor: pointer;
}
.skuBg {
  background: rgb(254, 66, 3) !important;
}
.handleBtn {
  margin: 5px;
}
</style>
